import { defineNuxtRouteMiddleware } from '#imports';
import { useAuth } from '@/composables/use-auth';
import { useFacilities } from '@/composables/use-facilities';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!process.client) return;
  
  // Define public routes that don't require authentication
  const publicRoutes = [
    '/splashscreen',
    '/forgot-password',
    '/signup',
    '/signup/account',
    '/signup/personal-details',
    '/signup/verify-email',
    '/signup/profile',
    '/signup/success',
    '/authentication-management/verify-email',
    '/authentication-management/verify-password-reset'
  ];

  // Skip middleware for public routes
  if (publicRoutes.includes(to.path) || to.path.startsWith('/signup/')) {
    return;
  }

  console.warn('running auth middleware');
  const { init } = useAuth();
  // const { getActiveFacility } = useFacilities();
  await init();
  // await getActiveFacility();
});